module.exports = __webpack_public_path__ + "img/logo_small.5e255622.svg";